var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMlynPop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 256,
    height: 110,
    viewBox: "0 0 256 110",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mlyn"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "47.4 49.5 161.64 17.27 188.1 3.87 208.6 45.54",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.94
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "49.06 49.01 79.31 34.29 187.27 3.54",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.62
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "53.52 48.35 53.52 92.49 159.99 103.24 159.99 18.75",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.62
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "105.43 60.91 94.19 71.82 66.91 74.14 77.49 64.72 105.43 60.91",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.62
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "207.44 45.21 202.15 45.21 202.15 106.21",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.62
  }), /*#__PURE__*/React.createElement("line", {
    x1: 71.37,
    y1: 73.97,
    x2: 78.15,
    y2: 80.59,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.94
  }), /*#__PURE__*/React.createElement("line", {
    x1: 77.99,
    y1: 94.81,
    x2: 77.99,
    y2: 73.64,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.94
  }), /*#__PURE__*/React.createElement("line", {
    x1: 104.94,
    y1: 62.07,
    x2: 104.94,
    y2: 96.95,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.94
  }), /*#__PURE__*/React.createElement("line", {
    x1: 96.84,
    y1: 70.34,
    x2: 105.1,
    y2: 79.93,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.94
  }), /*#__PURE__*/React.createElement("line", {
    x1: 78.15,
    y1: 63.89,
    x2: 78.15,
    y2: 41.4,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.94
  }), /*#__PURE__*/React.createElement("line", {
    x1: 104.44,
    y1: 60.42,
    x2: 104.44,
    y2: 34.29,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.94
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "93.86 40.58 87.58 42.56 87.58 61.08 93.86 60.09 93.86 40.58",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.81
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "69.23 47.19 63.77 48.51 63.77 60.09 69.23 59.42 69.23 47.19",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.81
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "69.23 73.81 63.77 74.32 63.77 86.7 69.23 86.69 69.23 73.81",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.81
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "127.92 32.15 119.32 34.13 119.32 48.68 127.92 47.52 127.92 32.15",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.81
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "127.92 70.84 119.32 71.33 119.32 87.7 127.92 88.03 127.92 70.84",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.81
  }), /*#__PURE__*/React.createElement("line", {
    x1: 96.5,
    y1: 96.29,
    x2: 96.5,
    y2: 70.17,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.81
  }), /*#__PURE__*/React.createElement("line", {
    x1: 85.43,
    y1: 95.14,
    x2: 85.43,
    y2: 72.82,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.81
  }), /*#__PURE__*/React.createElement("line", {
    x1: 118.66,
    y1: 97.95,
    x2: 118.66,
    y2: 30.33,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.81
  }), /*#__PURE__*/React.createElement("line", {
    x1: 129.57,
    y1: 99.27,
    x2: 129.57,
    y2: 25.86,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.81
  }), /*#__PURE__*/React.createElement("line", {
    x1: 69.72,
    y1: 93.15,
    x2: 69.72,
    y2: 73.97,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.81
  }), /*#__PURE__*/React.createElement("line", {
    x1: 69.39,
    y1: 71.16,
    x2: 69.39,
    y2: 43.39,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.81
  }), /*#__PURE__*/React.createElement("line", {
    x1: 63.6,
    y1: 45.21,
    x2: 63.6,
    y2: 92.66,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.81
  }), /*#__PURE__*/React.createElement("line", {
    x1: 66.41,
    y1: 48.18,
    x2: 66.41,
    y2: 59.59,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.81
  }), /*#__PURE__*/React.createElement("line", {
    x1: 66.08,
    y1: 86.04,
    x2: 66.08,
    y2: 74.47,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.81
  }), /*#__PURE__*/React.createElement("line", {
    x1: 123.45,
    y1: 48.18,
    x2: 123.45,
    y2: 33.47,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.81
  }), /*#__PURE__*/React.createElement("line", {
    x1: 123.62,
    y1: 87.53,
    x2: 123.62,
    y2: 71.33,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.81
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "178.01 34.46 172.72 31.98 172.72 47.36 178.01 49.17 178.01 34.46",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.81
  }), /*#__PURE__*/React.createElement("line", {
    x1: 175.37,
    y1: 33.3,
    x2: 175.37,
    y2: 48.02,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.81
  }), /*#__PURE__*/React.createElement("line", {
    x1: 83.94,
    y1: 72.82,
    x2: 83.94,
    y2: 95.3,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.32
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMlynPop);
export default __webpack_public_path__ + "static/media/mlyn_pop.f43181f1a88ea94e84e1d637c96e8f33.svg";
export { ForwardRef as ReactComponent };